import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000', 
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response, 
  async (error) => {
    if (error.response && error.response.status === 401) {
       console.error("Token invalide ou expiré (401). Déconnexion de l'utilisateur."); // Ligne corrigée
       
       try {
        const { store } = await import('../redux/store');
        const { clearToken } = await import('../redux/sign-in/signinSlice');
        
        store.dispatch(clearToken());

        window.location.href = '/sign-in';

       } catch (e) {
           console.error("Erreur lors de la déconnexion automatique:", e);
       }
    }
    return Promise.reject(error);
  }
);

export default apiClient;